import { motion } from "framer-motion";
import { CheckRoundedIcon } from "../../../../components/icons";
import { cn } from "../../../../utils/classnames";

const GOLD = "#DBBE78";

// One numbered dot plus its label. A finished step swaps its number for a tick.
const StepDot = ({ number, label, isActive, isDone }) => (
  <div className="tw:flex tw:items-center tw:gap-3 tw:shrink-0">
    <motion.div
      className={cn(
        "tw:flex tw:items-center tw:justify-center tw:w-8 tw:h-8 tw:rounded-full tw:text-[14px] tw:font-semibold tw:border tw:transition-colors tw:duration-300",
        isActive && "tw:bg-[#DBBE78] tw:border-[#DBBE78] tw:text-white",
        !isActive && !isDone && "tw:bg-white tw:border-[#D9D9D9] tw:text-[#8D8D8D]",
        isDone && "tw:border-transparent"
      )}
      // A small pop when the step becomes the current one.
      animate={{ scale: isActive ? [0.85, 1] : 1 }}
      transition={{ type: "spring", stiffness: 420, damping: 20 }}
    >
      {isDone ? <CheckRoundedIcon color={GOLD} size={32} /> : number}
    </motion.div>
    <span
      className={cn(
        "tw:text-[14px] tw:leading-tight tw:whitespace-nowrap tw:transition-colors tw:duration-300",
        isActive || isDone ? "tw:text-[#282828] tw:font-semibold" : "tw:text-[#8D8D8D]",
        // Phones only have room for the current step's label.
        !isActive && "tw:hidden tw:sm:inline"
      )}
    >
      {label}
    </span>
  </div>
);

/**
 * "1 Personal Information ──── 2 Payment Method" progress header.
 * `steps` is a list of labels; `currentStep` is 1-based.
 */
const RegisterStepper = ({ steps, currentStep }) => (
  <div className="tw:flex tw:items-center tw:gap-3 tw:w-full">
    {steps.map((label, index) => {
      const stepNumber = index + 1;
      const isLast = stepNumber === steps.length;

      return (
        <div key={label} className={cn("tw:flex tw:items-center tw:gap-3", !isLast && "tw:flex-1")}>
          <StepDot
            number={stepNumber}
            label={label}
            isActive={stepNumber === currentStep}
            isDone={stepNumber < currentStep}
          />
          {/* Connector line: fills with gold once the step before it is finished. */}
          {!isLast && (
            <div className="tw:relative tw:flex-1 tw:h-[2px] tw:min-w-6 tw:rounded-full tw:bg-[#E5E5E5] tw:overflow-hidden">
              <motion.div
                className="tw:absolute tw:inset-0 tw:origin-left tw:bg-[#DBBE78]"
                initial={false}
                animate={{ scaleX: stepNumber < currentStep ? 1 : 0 }}
                transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
          )}
        </div>
      );
    })}
  </div>
);

export default RegisterStepper;
